/**
 * Sports vs non-sports tag classification derived from the canonical
 * `onboarding-tags.json` taxonomy — every category except `NON_SPORTS_CATEGORIES`
 * is sports.
 */
/// <reference path="../onboarding-tags.d.ts" />
import { normalizeTag } from "../tagNormalization.js";
import { LEAGUE_TAGS } from "./creatorAcquisition.js";
import onboardingTags from "../onboarding-tags.json" with { type: "json" };
/** onboarding-tags.json categories that are NOT sports. */
const NON_SPORTS_CATEGORIES = new Set(["Above & Beyond", "Streaming", "Genres", "TV"]);
/** Stray non-sport labels inside sports categories (e.g. a leftover QA "test"). */
const EXCLUDED_TAGS = new Set(["test"]);
/** Generic sport words the taxonomy only lists as specific leagues. */
const GENERIC_SPORT_TAGS = [
    "sports", "sports-and-fitness", "soccer", "football", "basketball", "baseball",
    "hockey", "rugby", "racing", "tennis", "golf", "cricket", "volleyball",
    "softball", "lacrosse", "boxing", "mma", "ufc", "motorsport", "nascar",
    "europa-league", "champions-league", "wwe", "wrestling", "f1", "formula-1",
];
/** Normalized tag slugs classified as sports (taxonomy + generics + LEAGUE_TAGS). */
export const SPORTS_TAGS = new Set([
    ...Object.entries(onboardingTags)
        .filter(([category]) => !NON_SPORTS_CATEGORIES.has(category))
        .flatMap(([, labels]) => labels.map(normalizeTag)),
    ...GENERIC_SPORT_TAGS,
    ...LEAGUE_TAGS,
].filter((tag) => !EXCLUDED_TAGS.has(tag)));
/**
 * True when any of a calendar's tags identifies it as sports. Tags are
 * normalized before lookup, so display-form or Calendar-slug tags both match.
 */
export function hasSportsTag(tags) {
    return (tags ?? []).some((t) => {
        const tag = normalizeTag(t);
        return SPORTS_TAGS.has(tag) || tag.startsWith("college-");
    });
}
//# sourceMappingURL=sportsTags.js.map